import React from "react";
import OfftakeFilter from "../../Components/Filters/OfftakeFilter.jsx";
import { OfftakeKpi } from "./OfftakeKpi";
import { DayHourWise } from "./OfftakeStatics/DayHourWise.js";
import { RegionWise } from "./OfftakeStatics/RegionWise.js";
import CombinedOfftakeTables from "./OfftakeStatics/CombinedOfftakeTables.js";
import { LobOfftake } from "./OfftakeStatics/LobOfftake.js";

const Offtake = () => {
  return (
    <div className="flex flex-col flex-grow">
      <div className="px-2">
        <OfftakeFilter />
      </div>
      <div className="px-2 mt-1">
        <OfftakeKpi />
      </div>
      <div className="lg:flex gap-2 px-2 mb-2 md:block mt-2">
        <section className="lg:w-[75%] md:w-full">
          <div className="bg-white rounded-md">
            <DayHourWise />
          </div>
          <div className="lg:flex pt-2 gap-4 md:full">
            <div className="bg-white rounded-md lg:w-1/2 md:w-full">
              <RegionWise />
            </div>
            <div className="bg-white rounded-md lg:w-1/2 md:w-full mt-5 md:mt-0">
              <CombinedOfftakeTables />
            </div>
          </div>
        </section>
        <section className="lg:w-[25%] md:w-full mt-5 md:mt-0">
          <LobOfftake />
        </section>
      </div>
    </div>
  );
};

export default Offtake;
